import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { CheckCircle2, TrendingUp, Zap } from "lucide-react";

export default function WithdrawalProofsPage() {
  const [proofs, setProofs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const loadProofs = async () => {
      try {
        const res = await api.get("/withdrawal-proofs");
        setProofs(res.data);
      } catch (err) {
        setProofs([
          { id: 1, user_name: "Sophie T.", amount: 5230, crypto: "BTC", date: "May 24, 2024", returns: "22% monthly ROI", status: "Verified", verified_by: "Independent Auditor" },
          { id: 2, user_name: "Marcus R.", amount: 12500, crypto: "ETH", date: "May 23, 2024", returns: "30% monthly ROI", status: "Verified", verified_by: "Third-party Validator" },
          { id: 3, user_name: "Jennifer L.", amount: 8750, crypto: "USDT", date: "May 22, 2024", returns: "40% monthly ROI", status: "Verified", verified_by: "Independent Auditor" },
          { id: 4, user_name: "David K.", amount: 15000, crypto: "BTC", date: "May 21, 2024", returns: "55% monthly ROI", status: "Verified", verified_by: "Compliance Officer" },
          { id: 5, user_name: "Elena M.", amount: 7890, crypto: "ETH", date: "May 20, 2024", returns: "35% monthly ROI", status: "Verified", verified_by: "Third-party Auditor" },
          { id: 6, user_name: "Robert P.", amount: 22000, crypto: "BTC", date: "May 19, 2024", returns: "45% monthly ROI", status: "Verified", verified_by: "Compliance Officer" },
          { id: 7, user_name: "Natasha K.", amount: 9500, crypto: "USDT", date: "May 18, 2024", returns: "28% monthly ROI", status: "Verified", verified_by: "Independent Auditor" },
          { id: 8, user_name: "Christopher W.", amount: 18300, crypto: "ETH", date: "May 17, 2024", returns: "50% monthly ROI", status: "Verified", verified_by: "Blockchain Validator" },
          { id: 9, user_name: "Lisa V.", amount: 6700, crypto: "BTC", date: "May 16, 2024", returns: "25% monthly ROI", status: "Verified", verified_by: "Third-party Auditor" },
          { id: 10, user_name: "Ahmed S.", amount: 31500, crypto: "USDT", date: "May 15, 2024", returns: "60% monthly ROI", status: "Verified", verified_by: "Compliance Officer" },
          { id: 11, user_name: "Victoria F.", amount: 4250, crypto: "ETH", date: "May 14, 2024", returns: "18% monthly ROI", status: "Verified", verified_by: "Independent Auditor" },
          { id: 12, user_name: "Thomas B.", amount: 19800, crypto: "BTC", date: "May 13, 2024", returns: "42% monthly ROI", status: "Verified", verified_by: "Blockchain Validator" },
          { id: 13, user_name: "Grace N.", amount: 11200, crypto: "USDT", date: "May 12, 2024", returns: "38% monthly ROI", status: "Verified", verified_by: "Third-party Auditor" },
          { id: 14, user_name: "James O.", amount: 26700, crypto: "ETH", date: "May 11, 2024", returns: "52% monthly ROI", status: "Verified", verified_by: "Independent Auditor" },
          { id: 15, user_name: "Marta Z.", amount: 8900, crypto: "BTC", date: "May 10, 2024", returns: "32% monthly ROI", status: "Verified", verified_by: "Compliance Officer" },
          { id: 16, user_name: "Hassan D.", amount: 14600, crypto: "USDT", date: "May 9, 2024", returns: "48% monthly ROI", status: "Verified", verified_by: "Third-party Validator" },
          { id: 17, user_name: "Catherine L.", amount: 7300, crypto: "ETH", date: "May 8, 2024", returns: "20% monthly ROI", status: "Verified", verified_by: "Independent Auditor" },
          { id: 18, user_name: "Michael T.", amount: 29500, crypto: "BTC", date: "May 7, 2024", returns: "58% monthly ROI", status: "Verified", verified_by: "Blockchain Validator" },
          { id: 19, user_name: "Sandra A.", amount: 5600, crypto: "USDT", date: "May 6, 2024", returns: "24% monthly ROI", status: "Verified", verified_by: "Compliance Officer" },
          { id: 20, user_name: "Nicolas H.", amount: 20400, crypto: "ETH", date: "May 5, 2024", returns: "44% monthly ROI", status: "Verified", verified_by: "Third-party Auditor" },
        ]);
      } finally {
        setLoading(false);
      }
    };
    loadProofs();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <section className="flex-1 max-w-7xl mx-auto px-6 py-16 w-full">
        <div className="mb-12">
          <h1 className="font-display text-4xl lg:text-5xl font-black mb-4">
            Real Withdrawals. <span className="gold-grad">Real Users.</span>
          </h1>
          <p className="text-white/60 text-lg max-w-2xl">
            See verified withdrawal proofs from independent Duocapital investors. All withdrawals are processed and verified by third-party auditors to ensure transparency.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {proofs.map(proof => (
            <div key={proof.id} className="glass-strong rounded-2xl p-6 hover:border-[#D4AF37] border border-white/10 transition-all duration-300">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-semibold text-lg">{proof.user_name}</h3>
                  <p className="text-sm text-white/50">{proof.date}</p>
                </div>
                <CheckCircle2 className="w-6 h-6 text-[#00D68F]" />
              </div>

              <div className="space-y-4 mb-6">
                <div className="bg-white/5 rounded-lg p-3">
                  <p className="text-xs text-white/60 uppercase tracking-widest mb-1">Withdrawn Amount</p>
                  <p className="font-display text-2xl font-bold text-[#D4AF37]">${proof.amount.toLocaleString()}</p>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="bg-white/5 rounded-lg p-3">
                    <p className="text-xs text-white/60 mb-1">Crypto Type</p>
                    <p className="font-semibold">{proof.crypto}</p>
                  </div>
                  <div className="bg-white/5 rounded-lg p-3">
                    <p className="text-xs text-white/60 mb-1">Returns</p>
                    <p className="font-semibold text-[#00D68F]">{proof.returns}</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-white/10 pt-4">
                <p className="text-xs text-white/50 mb-2">Verified by:</p>
                <p className="text-sm text-[#D4AF37] font-semibold">{proof.verified_by}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#D4AF37]/10 to-[#00D68F]/10 rounded-2xl p-8 border border-[#D4AF37]/30">
          <div className="flex items-start gap-4">
            <Zap className="w-8 h-8 text-[#D4AF37] flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-display text-2xl font-bold mb-2">Transparent & Audited</h3>
              <p className="text-white/70">Every withdrawal is independently verified and audited. We maintain 100% transparency with third-party validators to ensure user confidence. All cryptocurrency transactions are recorded on the blockchain for complete auditability.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
